// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// import Projects from '../../api/project'
// import SectionTitle from '../SectionTitle';

// const ProjectSectionS2 = () => {
//     const navigate = useNavigate();

//     const handleProjectClick = (projectId) => {
//         navigate(`/project-single/${projectId}`);
//     };




//     return (
//         <div className="wpo-project-area-s2 section-padding">
//             <div className="container">
//                 <SectionTitle subTitle={'Featured Works'} MainTitle={'Our Projects'} />
//                 <div className="row align-items-center">
//                     <div className="wpo-project-wrap">
//                         <div className="sortable-gallery">
//                             <div className="row">
//                                 <div className="col-lg-12">
//                                     <div className="project-grids gallery-container clearfix">
//                                         {Projects.map((project, pot) => (
//                                             <div className="grid" key={pot}>
//                                                 <div className="wpo-project-item" >
//                                                     <div className="wpo-project-img">
//                                                         <img src={project.pImg} alt="" />
//                                                         <div className="left-border"></div>
//                                                         <div className="right-border"></div>
//                                                     </div>
//                                                     <div className="wpo-project-text">
//                                                         <h2>{project.title}</h2>
//                                                         <span>{project.subTitle}</span>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default ProjectSectionS2;

























import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getOurProjects } from "../../api/Projects";
import SectionTitle from "../SectionTitle";

const ProjectSectionS2 = () => {
  const navigate = useNavigate();
  const [projectData, setProjectData] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      const data = await getOurProjects();
      setProjectData(data);
    };
    fetchProjects();
  }, []);

  if (!projectData) return null; // or a loader

  const handleProjectClick = (projectId) => {
    navigate(`/project-single/${projectId}`);
  };

  return (
    <div className="wpo-project-area-s2 section-padding">
      <div className="container">
        <SectionTitle
          subTitle={projectData.subtitle}
          MainTitle={projectData.MainTitle}
        />
        <div className="row align-items-center">
          <div className="wpo-project-wrap">
            <div className="sortable-gallery">
              <div className="row">
                <div className="col-lg-12">
                  <div className="project-grids gallery-container clearfix">
                    {projectData.ourprojects.map((project, index) => (
                      <div
                        className="grid"
                        key={index}
                        onClick={() => handleProjectClick(project.id)}
                      >
                        <div className="wpo-project-item">
                          <div className="wpo-project-img">
                            <img
                              src={project.image}
                              alt={project.overlay_content_title}
                            />
                            <div className="left-border"></div>
                            <div className="right-border"></div>
                          </div>
                          <div className="wpo-project-text">
                            <h2>{project.overlay_content_title}</h2>
                            <span>{project.overlay_content_subtitle}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSectionS2;
